import { Injectable, inject } from '@angular/core';
import { ComponentStoreFactory } from '../../../../../shared/store/common/component-store.factory';
import { ServiceSettingsGqlService } from '../../../../../../services/service-settings.gql-service';
import { Store } from '@ngrx/store';

interface State {
}

const defaultState: State = {};

@Injectable()
export class ServiceWorkgroupModalStore extends ComponentStoreFactory<State> {
    constructor() {
        super(defaultState, inject(Store), inject(ServiceSettingsGqlService));
    }
}
